import { Autocomplete, TextField } from "@mui/material";
import { memo, useEffect, useState } from "react";
import RotinaDataSet from "../data/RotinaDataSet";
import Rotina from "../classes/Rotina";
import { hasInCache } from "../../helper/cacheHelper";
import { useTranslation } from "react-i18next";

function AutocompleteRotina(props: AutocompleteParceiroProps) {
    const { t } = useTranslation();
    const dataSet = new RotinaDataSet();
    const [data, setData] = useState<Rotina[]>([]);
    const [dataFilter, setDataFilter] = useState<Rotina[]>([]);

    useEffect(() => {
        dataSet.Listar().then((result) => {
            setData(result);
        });
    }, [])


    useEffect(() => {
        if (dataFilter !== null && dataFilter !== undefined && dataFilter.length === 1) {
            localStorage.setItem("codigoRotinaSel", String(dataFilter[0].id));
            if (props.onChange) {
                props.onChange(dataFilter[0]);
            }
        } else
            if (dataFilter.length !== 1)
                localStorage.removeItem("codigoRotinaSel");
    }, [dataFilter])

    const handlerOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setDataFilter(data.filter(f => f.id.toString().startsWith(event.target.value)))
    }

    return (
        <>
            <Autocomplete
                freeSolo
                id="autocompleteRotina"
                disableClearable
                options={data.map((option: any) => option.id + ' - ' + option.nome)}
                onChange={(e) => { setDataFilter(data.filter(f => (f.id.toString() + ' - ' + f.nome) === String(e.currentTarget.textContent))); }}
                renderInput={(params) => (<TextField
                    {...params}
                    label={t("pages.portal.text.searchRoutine")}
                    InputProps={{
                        ...params.InputProps,
                        type: 'search',
                    }}
                    onChange={handlerOnChange}
                />
                )}
            />
        </>
    )
}

interface AutocompleteParceiroProps {
    onChange?: (rotina: Rotina) => any;
}

export default memo(AutocompleteRotina);
